import { defineStore } from "pinia";
import { getQueryString, asyncProcessArray,filterMess} from '@/assets/js/index';
import { useScroll } from './scroll'
import { groupGet, history, getGroupList,setNotRead,getNotClear,getNotReadList} from '@/api/index';
import { closeToast,showToast } from 'vant';
import { useWork } from "./work";
export const useSocket = defineStore("socket", {
  state: () => ({
    comments: [], // 聊天记录
    group: {},
    user: {},
    groupList: [],
    hasMore: true,
    orderType:[], // 订单类型
    dislog: {
      player: null,
      his: false,
      order: false, // 订单
      product: false, // 商品
      tool: false, // 工具栏
      emoji: false // 表情包
    },
    messageQueue: [] // 消息队列
  }),
  actions: {
    setOrderType(data){
      this.orderType = data;
    },
    async setUser(user) {
      this.user = user;
    },
    listenNums(){
      const groupList = JSON.parse(JSON.stringify(this.groupList)),  
          ids = groupList.map((item) => item.id);                        
      getNotReadList({ wxappId: useWork().auth.wxappId }).then((res) => {    
        // 遍历接口返回的未读数据
        Object.entries(res).forEach(([groupId, nums]) => {
          const index = ids.indexOf(groupId*1);
          if (index !== -1) {
            groupList[index].offlineCount = nums;
          } else {
            console.log('未读数据中没有该群组的ID:', groupId,ids);  
            this.getGroupInit();
            return; 
          }
        });        
        this.groupList = groupList;
      });
    },
    async getGroupInit() {
      const group = await getGroupList({ wxappId: useWork().auth.wxappId });
      this.groupList = group;
    },
    async addGroupAndChat(data) {
      const groupList =JSON.parse(JSON.stringify(this.groupList));
      const ids = groupList.map((item) => item.id);
      if (ids.indexOf(data.groupId) < 0) {
        this.getGroupInit();
      } else {
        const index = groupList.findIndex((item) => item.id === data.groupId);
        groupList[index].lastContent = filterMess(data.content, data.type)
        groupList[index].offlineCount += 1;
        this.setNotReadPut(data.groupId);
        this.groupList=groupList;
      }
    },
    async setNotReadPut(id) {
      setNotRead({ groupId: id, wxappId: useWork().auth.wxappId })
    },
    clearNoRead(id,index) {
      const groupList =JSON.parse(JSON.stringify(this.groupList));
      if (id) {
        if(groupList[index].offlineCount > 0) {
          getNotClear({ groupId: id, wxappId: useWork().auth.wxappId })
          groupList[index].offlineCount = 0;
          this.groupList=groupList
        }
      } else {
       const noReadNums= groupList.reduce((acc, ele) => acc + ele.offlineCount, 0);
       if(noReadNums > 0) {
        getNotClear({wxappId: useWork().auth.wxappId })
        groupList.forEach(ele => {
          ele.offlineCount = 0;
        });
        this.groupList=groupList
        showToast('已清除所有未读消息') 
       }else{
        showToast('没有未读消息') 
       }
      }
    },
    seeOP(key, bool) {
      this.dislog[key] = bool;
    },
    visible(key, bool) {
      const now = Date.now();
      if (now - (this.lastVisibleTime || 0) < 200) { // 200ms内不能重复执行
        return;
      }
      
      this.lastVisibleTime = now;
      
      const dialog = Object.keys(this.dislog).reduce((acc, k) => {
        acc[k] = false;
        return acc;
      }, {});
      
      dialog[key] = bool; 
      console.log(dialog);
      this.dislog = dialog;
    },
    async getHistory(data) {
      return new Promise(resolve => {
        const newData = Object.assign({ groupId: this.group.id, wxappId: useWork().auth.wxappId }, data);
        history(newData).then(async (response) => {
          if (!response) response = [];
          if (response.length < 20) { this.hasMore = false; }
          const newData = response.map(ele => ({
            id: ele.id,
            avatar: ele.avatar,
            content: ele.message,
            groupId: ele.groupId,
            type: ele.type,
            nickname: ele.nickname,
            userType: ele.userType,
            createTime: ele.createTime,
            chatType: ele.chatType,
            quotedMessageId: ele.quotedMessageId,
            quotedMessage: ele.quotedMessage,
          }));
          const nlist = await asyncProcessArray(newData);
          resolve(nlist);
        });
      });
    },
    async init() {
      const query = getQueryString('groupId') ? { groupId: getQueryString('groupId') } : { supplierCode: getQueryString('code').toUpperCase() };
      const groupData = await groupGet(Object.assign(query, { wxappId: useWork().auth.wxappId }));
      if (groupData) {
        document.title = groupData.supplierName
      }
      this.group = groupData;
      this.hasMore = true;
      const his = await this.getHistory();
      this.setComment(his);
    },
    reCall(Index){
      this.comments.splice(Index,1);
    },
    setComment(data) {
      this.comments = data.map(item => ({
        ...item,
        updatedAt: new Date().getTime() // 添加更新时间戳
      }))
    },
    addComment(data) {
      console.log('datas', data)
      this.comments.push(data);
    },
    async sendMess(data, isrobot) {
      if (!useWork().isConnect) {
        console.error("Cannot send message: Not connected to the server. Attempting to reconnect...");
        useWork().reconnect();
        return;
      }
      let res = {
        content: data.content,
        groupId: this.group.id,
        type: data.type,
      };
      try {
        const response = await useWork().socket
          .timeout(10000)
          .emitWithAck("message", res)
          .catch(err => {
            throw new Error(`Socket请求失败: ${err.message}`)
          })
        const errorResponse = {
          code: response?.code || -1,
          message: response?.message || '未知错误',
          timestamp: Date.now()
        }
        console.log('响应详情:', response)
        console.log('错误响应:', errorResponse)
        if (response.code === 0) {
          if (!isrobot) {
            const nData = response.data;
            const newMsg = {
              content: nData.message,
              groupId: nData.groupId,
              id: nData.id,
              type: nData.type,
              nickname: nData.nickname,
              avatar: nData.avatar,
              userType: nData.userType,
              chatType: nData.chatType,
            };
            console.log(newMsg)
            this.addComment(newMsg);
            useScroll().toBottom();
          }
        }
      } catch (error) {
        const errorType = error instanceof Error ? error.message : '未知异常类型'
        const errorLog = {
          code: error.code || 500,
          type: errorType,
          stack: error.stack || '无堆栈信息',
          timestamp: Date.now()
        }
        console.error('全局捕获:', errorLog)
        console.warn('业务异常码:', error)
        if (error.message.includes('timeout')) {
          showToast('请求超时，请检查网络')
        } else if (error.message.includes('Socket')) {
          showToast('服务连接异常，请稍后重试')
        } else {
          showToast('系统繁忙，请稍后再试')
        }

        this.status = error.code || 500
      }finally {
        closeToast()
      }
    },
  }
});